export default __webpack_public_path__ + "static/media/img6.c8b0ffc5.svg";